import script from "./ChallengeEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./ChallengeEntry.vue?vue&type=script&setup=true&lang=js"

import "./ChallengeEntry.vue?vue&type=style&index=0&id=49dc3ef0&scoped=true&lang=css"

import exportComponent from "/Users/ffavreau/www/canton-dans-le-bouillon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49dc3ef0"]])

export default __exports__